var _excluded = ["title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgShare = function SvgShare(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Share' : _ref$title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,30.707 L14,30.707 C14,19.698 22.832,11.707 35,11.707 L44.586,11.707 L34.293,1.414 L35.707,0 L48.414,12.707 L35.707,25.414 L34.293,24 L44.586,13.707 L35,13.707 C23.813,13.707 16,20.698 16,30.707"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40 43.707 0 43.707 0 9.707 13 9.707 13 11.707 2 11.707 2 41.707 38 41.707 38 30.707 40 30.707"
  }));
};
SvgShare = pure(SvgShare);
SvgShare.displayName = 'SvgShare';
export default SvgShare;